<template>
  <modal
    :show.sync="showPaymentMethodModal"
    modal-classes="modal-dialog-centered modal-md"
    body-classes
    @close="closeOnClick(paymentMethodType)"
    no-close-on-backdrop
  >
    <template slot="header">
      <h5 class="subtitle" id="modalcolumns">Payment Method</h5>
    </template>

    <div class="row align-items-center mt-3 forms">
      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12 switch-x-l mb-3">
        <label class="title-label">Type Method</label>

        <b-form-group v-slot="ariaDescribedby3" class="mb-0">
          <b-form-radio-group
            v-model="paymentMethodType"
            @change="selectPaymentMethodType"
            :aria-describedby="ariaDescribedby3"
            id="radio-commercial"
            name="radio-comercial"
            :disabled="type === 'edit'"
            buttons
            button-variant="outline-neutral"
            size="md"
            class="pc-0"
          >
            <b-form-radio value="paypal" tabindex="18">Paypal</b-form-radio>
            <b-form-radio value="bank_account">Bank Account</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>

      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        v-if="paymentMethodType === 'paypal'"
      >
        <base-input
          v-model.trim="$v.paypal.email.$model"
          label="Email Account"
          id="email_account"
          name="email_account"
          markrequired
          maxlength="45"
          :error="$v.paypal.email.$error ? `Enter a Valid email` : ''"
        />
      </div>

      <div class="col-xl-12" v-if="paymentMethodType === 'bank_account'">
        <div class="row">
          <div class="col-xl-12 col-12">
            <base-input
              v-model.trim="$v.bank_account.name_account.$model"
              label="Account Holder / Business Name"
              id="business_name"
              name="business_name"
              maxlength="45"
              markrequired
              :error="
                !$v.bank_account.name_account.minLength ||
                $v.bank_account.name_account.$error
                  ? `Enter ${$v.bank_account.name_account.$params.minLength.min} to ${$v.bank_account.name_account.$params.maxLength.max} characters`
                  : ''
              "
            />
          </div>

          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <WSelect
              v-model.trim="$v.bank_account.type_transfer.$model"
              label="Transfer Type"
              placeholder="Transfer Type"
              id="transfer_type"
              name="transfer_type"
              filterable
              clearable
              markrequired
              @change="changeTypeTransfer"
              :error="
                !$v.bank_account.type_transfer.minLength ||
                $v.bank_account.type_transfer.$error
                  ? `Select a Type Transfer`
                  : ''
              "
            >
              <el-option
                v-for="types in transfer_types"
                :value="types.value"
                :label="types.label"
                :key="types.label"
              ></el-option>
            </WSelect>
          </div>

          <div
            class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
            v-if="
              bank_account.type_transfer === 'ach' ||
                bank_account.type_transfer === 'wire'
            "
          >
            <WSelect
              v-model.trim="$v.bank_account.account_type.$model"
              label="Account Type"
              placeholder="Account Type"
              id="account_type"
              name="account_type"
              filterable
              clearable
              markrequired
              :error="
                !$v.bank_account.account_type.minLength ||
                $v.bank_account.account_type.$error
                  ? `Select an Account Type`
                  : ''
              "
            >
              <el-option
                v-for="types in account_types"
                :value="types.value"
                :label="types.label"
                :key="types.label"
              ></el-option>
            </WSelect>
          </div>

          <div
            class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
            v-if="
              bank_account.type_transfer === 'swift' ||
                bank_account.type_transfer === 'transfer_gbp'
            "
          ></div>
          <div
            class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
            v-if="
              bank_account.type_transfer === 'ach' ||
                bank_account.type_transfer === 'wire'
            "
            v-bind:class="{
              'is-invalid': $v.bank_account.routing_number.$error
            }"
          >
            <label
              for="routing-number"
              class="title-label"
              v-if="bank_account.type_transfer === 'ach'"
              ><span class="markrequired">*</span>ACH Routing Number
            </label>

            <label
              for="routing-number"
              class="title-label"
              v-if="bank_account.type_transfer === 'wire'"
              ><span class="markrequired">*</span>Fedwire Routing Number
            </label>

            <base-input
              v-model.trim="$v.bank_account.routing_number.$model"
              id="routing_number"
              name="routing_number"
              maxlength="11"
              markrequired
              :error="
                !$v.bank_account.routing_number.minLength ||
                $v.bank_account.routing_number.$error
                  ? `Enter 9 numbers`
                  : ''
              "
            />
          </div>

          <div
            class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
            v-if="bank_account.type_transfer === 'swift'"
          >
            <base-input
              v-model.trim="$v.bank_account.swift_code.$model"
              label="SWIFT Code / BIC Code"
              id="bank_account_code"
              name="bank_account_code"
              maxlength="11"
              markrequired
              :error="
                !$v.bank_account.swift_code.minLength ||
                $v.bank_account.swift_code.$error
                  ? `Enter 8 to 11 characters.`
                  : ''
              "
            />
          </div>

          <div
            class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
            v-if="bank_account.type_transfer === 'transfer_gbp'"
          >
            <base-input
              v-model.trim="$v.bank_account.uk_sort_code.$model"
              label="UK Sort Code"
              id="uk_sort_code"
              name="uk_sort_code"
              maxlength="6"
              :error="
                !$v.bank_account.uk_sort_code.minLength ||
                $v.bank_account.uk_sort_code.$error
                  ? `Enter 6 numbers`
                  : ''
              "
            />
          </div>

          <div
            class="col-xl-12 col-12"
            v-bind:class="{
              'is-invalid': $v.bank_account.account_number.$error
            }"
          >
            <label
              for="account_number"
              class="title-label"
              v-if="bank_account.type_transfer === 'transfer_eur'"
              ><span class="markrequired">*</span>IBAN
            </label>

            <label
              for="account_number"
              class="title-label"
              v-else-if="bank_account.type_transfer === 'swift'"
              ><span class="markrequired">*</span>IBAN / Account Number
            </label>

            <label for="account_number" class="title-label" v-else
              ><span class="markrequired">*</span>Account Number
            </label>
            <base-input
              v-model.trim="$v.bank_account.account_number.$model"
              id="account_number"
              name="account_number"
              maxlength="34"
              markrequired
              :error="ibanValidationMessage($v.bank_account.account_number)"
            />
          </div>

          <div class="col-xl-12 mb-3">
            <label for="" class="title-label-np"
              ><strong>Recipient Address</strong>
            </label>
          </div>

          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <WSelect
              v-model="$v.bank_account.country.$model"
              label="Country"
              placeholder="Enter a Country"
              id="bank_account_country"
              name="bank_account_country"
              filterable
              remote
              reserve-keyword
              :remote-method="searchCountry"
              :loading="loading"
              clearable
              markrequired
              :error="
                !$v.bank_account.country.minLength ||
                $v.bank_account.country.$error
                  ? `Select a Country`
                  : ''
              "
            >
              <el-option
                v-for="country in countriesOptions"
                :value="country.name"
                :label="country.name"
                :key="country.name"
              ></el-option>
            </WSelect>
          </div>

          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <base-input
              v-model.trim="$v.bank_account.city.$model"
              label="City"
              id="bank_account_city"
              name="bank_account_city"
              maxlength="50"
              markrequired
              :error="
                !$v.bank_account.city.minLength || $v.bank_account.city.$error
                  ? `Enter ${$v.bank_account.city.$params.minLength.min} to ${$v.bank_account.city.$params.maxLength.max} characters`
                  : ''
              "
            />
          </div>

          <div class="col-xl-12 col-12">
            <base-input
              v-model.trim="$v.bank_account.address.$model"
              label="Recipient Address"
              id="bank_account_address"
              name="bank_account_address"
              maxlength="100"
              markrequired
              :error="
                !$v.bank_account.address.minLength ||
                $v.bank_account.address.$error
                  ? `Enter ${$v.bank_account.address.$params.minLength.min} to ${$v.bank_account.address.$params.maxLength.max} characters`
                  : ''
              "
            />
          </div>

          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <base-input
              v-model.trim="$v.bank_account.post_code.$model"
              label="Zip/Postal Code"
              id="bank_account_post_code"
              name="bank_account_post_code"
              maxlength="10"
              markrequired
              :error="
                !$v.bank_account.post_code.minLength ||
                $v.bank_account.post_code.$error
                  ? `Enter ${$v.bank_account.post_code.$params.minLength.min} to ${$v.bank_account.post_code.$params.maxLength.max} characters.`
                  : ''
              "
            />
          </div>
        </div>
      </div>
    </div>

    <template slot="footer">
      <base-button
        type="outline-neutral "
        class="min-button"
        @click="closeOnClick(paymentMethodType)"
        ><i class="flaticon-cancel"></i>Cancel</base-button
      >

      <base-button
        type="primary"
        v-if="type === 'create'"
        class="min-button ml-auto mb-0"
        @click="addPaymentMethod()"
        ><i class="flaticon-floppy-disk"></i> Save</base-button
      >
      <base-button
        type="primary"
        v-else
        class="min-button ml-auto mb-0"
        @click="editPaymentMethod()"
        ><i class="flaticon-floppy-disk"></i>Update</base-button
      >
    </template>
  </modal>
</template>

<script>
// @ is an alias to /src
import { mapMutations, mapGetters, mapActions } from "vuex";
import WSelect from "@/components/Select";
import {
  required,
  minLength,
  maxLength,
  email,
  requiredIf,
  helpers,
  numeric
} from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
const formatSwiftCode = helpers.regex(
  "alphaCha",
  /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{8,11}$/
);

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import lodash from "lodash";
import Swal from "sweetalert2";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "PaymentMethods",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    WSelect
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    paymentMethod: {
      type: Object,
      default: () => null
    }
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showPaymentMethodModal = current;
      },
      deep: true
    },
    paymentMethod: {
      handler: function(current, old) {
        if (current) {
          this.paymentMethodType = current.type;
          if (this.paymentMethodType === "paypal") {
            this.paypal.email = current.email;
            this.paypal.default = current.default;
            this.paypalCopy = lodash.cloneDeep(this.paypal);
          } else {
            this.bank_account.name_account = current.name_account;
            this.bank_account.type_transfer = current.type_transfer;
            this.bank_account.routing_number = current.routing_number;
            this.bank_account.account_number = current.account_number;
            this.bank_account.account_type = current.account_type;
            this.bank_account.swift_code = current.swift_code;
            this.bank_account.uk_sort_code = current.uk_sort_code;
            this.bank_account.country = current.country;
            this.bank_account.city = current.city;
            this.bank_account.address = current.address;
            this.bank_account.post_code = current.post_code;
            this.bank_account.default = current.default;
            this.bankAccountCopy = lodash.cloneDeep(this.bank_account);
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      showPaymentMethodModal: false,
      paymentMethodType: "paypal",
      paypal: {
        email: "",
        default: false
      },
      type_transfer: "",
      bank_account: {
        type_transfer: "",
        name_account: "",
        routing_number: "",
        account_number: "",
        account_type: "",
        swift_code: "",
        uk_sort_code: "",
        country: "",
        city: "",
        address: "",
        post_code: "",
        default: false
      },
      payment_method: {
        type: ""
      },
      loading: false,
      countriesOptions: [],
      paypalCopy: {},
      bankAccountCopy: {},
      transfer_types: [
        { label: "ACH", value: "ach" },
        { label: "WIRE", value: "wire" },
        { label: "SWIFT", value: "swift" },
        { label: "Transfer to EUR", value: "transfer_eur" },
        { label: "Transfer to GBP", value: "transfer_gbp" }
      ],
      account_types: [
        { label: "Savings", value: "savings" },
        { label: "Checking", value: "checking" }
      ]
    };
  },
  async created() {
    this.countriesOptions = this.countries;
    this.paypalCopy = lodash.cloneDeep(this.paypal);
    this.bankAccountCopy = lodash.cloneDeep(this.bank_account);
  },
  methods: {
    addPaymentMethod() {
      if (this.paymentMethodType === "paypal") {
        if (!this.$v.paypal.$invalid) {
          this.$emit("addPaymentMethod", {
            type: this.paymentMethodType,
            ...this.paypal
          });
          this.closePaymentMethodModal();
        } else {
          this.$v.paypal.$touch();
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
        }
      } else {
        if (!this.$v.bank_account.$invalid) {
          this.$emit("addPaymentMethod", {
            type: this.paymentMethodType,
            ...this.bank_account
          });
          this.closePaymentMethodModal();
        } else {
          this.$v.bank_account.$touch();
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
        }
      }
    },
    editPaymentMethod() {
      if (this.paymentMethodType === "paypal") {
        if (!this.$v.paypal.$invalid) {
          this.$emit("editPaymentMethod", {
            type: this.paymentMethodType,
            ...this.paypal
          });
          this.closePaymentMethodModal();
        } else {
          this.$v.paypal.$touch();
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
        }
      } else {
        if (!this.$v.bank_account.$invalid) {
          this.$emit("editPaymentMethod", {
            type: this.paymentMethodType,
            ...this.bank_account
          });
          this.closePaymentMethodModal();
        } else {
          this.$v.bank_account.$touch();
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
        }
      }
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The text has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The text couldn't be copied",
        icon: "flaticon-remove"
      });
    },
    searchCountry(value) {
      if (value !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.countriesOptions = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
          });
        }, 100);
      } else {
        this.countriesOptions = [];
      }
    },
    closePaymentMethodModal() {
      this.resetData();
      this.showPaymentMethodModal = false;
      this.$emit("closeModal", false);
    },
    resetData() {
      this.paypal.email = "";
      this.paypal.default = false;
      this.clearFieldsBankAccount();
      this.bank_account.name_account = "";
      this.bank_account.type_transfer = "";
      this.bank_account.country = "";
      this.bank_account.city = "";
      this.bank_account.address = "";
      this.bank_account.post_code = "";
      this.bank_account.default = false;
      this.paypalCopy = lodash.cloneDeep(this.paypal);
      this.bankAccountCopy = lodash.cloneDeep(this.bank_account);
      this.$v.bank_account.$reset();
      this.$v.paypal.$reset();
    },
    selectPaymentMethodType(type) {
      if (type === "paypal") {
        this.clearFieldsBankAccount();
        this.bank_account.name_account = "";
        this.bank_account.type_transfer = "";
        this.bank_account.country = "";
        this.bank_account.city = "";
        this.bank_account.address = "";
        this.bank_account.post_code = "";
        this.bank_account.default = false;
        this.bankAccountCopy = lodash.cloneDeep(this.bank_account);
        this.$v.bank_account.$reset();
      } else {
        this.paypal.email = "";
        this.paypal.default = false;
        this.paypalCopy = lodash.cloneDeep(this.paypal);
        this.$v.paypal.$reset();
      }
    },
    clearFieldsBankAccount() {
      this.bank_account.routing_number = "";
      this.bank_account.account_number = "";
      this.bank_account.account_type = "";
      this.bank_account.swift_code = "";
      this.bank_account.uk_sort_code = "";

      this.bank_account.default = false;
      this.$v.bank_account.$reset();
    },
    changeTypeTransfer() {
      this.clearFieldsBankAccount();
    },
    ibanValidationMessage(iban) {
      if (iban.$error) {
        if (!iban.maxLength) {
          return `To ${iban.$params.maxLength.max} characters`;
        } else if (!iban.required) {
          if (this.bank_account.type_transfer === "transfer_eur") {
            return "Enter IBAN";
          } else if (this.bank_account.type_transfer === "swift") {
            return "Enter IBAN/Account Number";
          } else {
            return "Enter Account Number";
          }
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    async closeOnClick(paymentMethodType) {
      this.showPaymentMethodModal = true;
      let isEqual =
        paymentMethodType === "paypal"
          ? lodash.isEqual(this.paypal, this.paypalCopy)
          : lodash.isEqual(this.bank_account, this.bankAccountCopy);

      await this.detectChanges(isEqual);
    },
    async detectChanges(isEqual) {
      if (!isEqual) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The Payment method has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          if (this.type === "create") {
            this.addPaymentMethod();
          } else {
            this.editPaymentMethod();
          }
        } else if (dismiss === Swal.DismissReason.cancel) {
          this.closePaymentMethodModal();
        }
      } else {
        this.closePaymentMethodModal();
      }
    },
    ...mapActions(["getAgents", "getLimit"]),
    ...mapMutations(["setLoad", "setItemsBread"])
  },
  computed: {
    ...mapGetters(["countries"])
  },
  filters: {},
  validations: {
    paypal: {
      email: {
        email,
        required: requiredIf(function(value) {
          return this.paymentMethodType === "paypal";
        })
      }
    },
    bank_account: {
      name_account: {
        required: requiredIf(function(value) {
          return this.paymentMethodType === "bank_account";
        }),
        minLength: minLength(2),
        maxLength: maxLength(45)
      },
      type_transfer: {
        minLength: minLength(3),
        maxLength: maxLength(20),
        required: requiredIf(function(value) {
          return this.paymentMethodType === "bank_account";
        })
      },
      routing_number: {
        minLength: minLength(9),
        maxLength: maxLength(9),
        required: requiredIf(function(value) {
          return (
            (this.paymentMethodType === "bank_account" &&
              this.bank_account.type_transfer === "ach") ||
            (this.paymentMethodType === "bank_account" &&
              this.bank_account.type_transfer === "wire")
          );
        })
      },
      account_type: {
        minLength: minLength(3),
        maxLength: maxLength(11),
        required: requiredIf(function(value) {
          return (
            (this.paymentMethodType === "bank_account" &&
              this.bank_account.type_transfer === "ach") ||
            (this.paymentMethodType === "bank_account" &&
              this.bank_account.type_transfer === "wire")
          );
        })
      },
      swift_code: {
        minLength: minLength(8),
        maxLength: maxLength(11),
        formatSwiftCode,
        required: requiredIf(function(value) {
          return (
            this.paymentMethodType === "bank_account" &&
            this.bank_account.type_transfer === "swift"
          );
        })
      },

      uk_sort_code: {
        minLength: minLength(6),
        maxLength: maxLength(6),
        numeric,
        required: requiredIf(function(value) {
          return (
            this.paymentMethodType === "bank_account" &&
            this.bank_account.type_transfer === "transfer_gbp"
          );
        })
      },
      account_number: {
        required: requiredIf(function(value) {
          return this.paymentMethodType === "bank_account";
        }),
        maxLength: maxLength(34)
      },
      address: {
        minLength: minLength(5),
        maxLength: maxLength(100),
        required: requiredIf(function(value) {
          return this.paymentMethodType === "bank_account";
        })
      },
      country: {
        ValName,
        minLength: minLength(3),
        maxLength: maxLength(50),
        required: requiredIf(function(value) {
          return this.paymentMethodType === "bank_account";
        })
      },
      city: {
        ValName,
        minLength: minLength(3),
        maxLength: maxLength(50),
        required: requiredIf(function(value) {
          return this.paymentMethodType === "bank_account";
        })
      },

      post_code: {
        minLength: minLength(4),
        maxLength: maxLength(10),
        required: requiredIf(function(value) {
          return this.paymentMethodType === "bank_account";
        })
      }
    }
  }
};
</script>
<style lang="scss"></style>
